//预加载图片资源
export default [
	require('@/assets/img/theme/new-year/gongxifacai_01.png'),
	require('@/assets/img/theme/new-year/wanshiruyi_01.png')
];
